import { styled } from "@mui/material/styles"
import { SignedOutPage } from "auth/SignedOutPage"
import LoadingPage from "components/Loading/LoadingPage"
import { knownComponents } from "generated/knownRouteComponents"
import { useContext, useEffect, useState } from "react"
import { Redirect, Route, Switch, useLocation } from "react-router-dom"
import Dashboard from "../pages/dashboard"
import { AppContext } from "./AppContextProvider"
import { RenderComponent } from "./RenderComponent"
import ScrollToTop from "./navigation/ScrollToTop"
const drawerWidth = "240px"
const StyledMain = styled("main")(({ theme, openDrawer }) => ({
  flexGrow: 1,
  background: theme.palette.background.default,
  minHeight: "100vh",
  [theme.breakpoints.up("sm")]: {
    marginLeft: !openDrawer ? `56px` : drawerWidth
  }
}))

const StyledSwitchWrapper = styled("div")(({ theme }) => ({
  // paddingTop: "88px",
  [theme.breakpoints.up("sm")]: {
    // paddingTop: "48px",
    height: "100%",
    "& > div": {
      position: "relative",
      height: "100%"
    }
  }
}))

const PagesRouter = (props) => {
  const appContext = useContext(AppContext)
  const location = useLocation()

  const [routes, setRoutes] = useState([])

  useEffect(() => {
    setRoutes(appContext.appUser.app.routes)
  }, [appContext])

  // const useStyles = makeStyles((theme) => ({
  //   content: {
  //     flexGrow: 1,
  //     background: theme.palette.background.default,
  //     minHeight: "100vh"
  //   },
  //   root: {
  //     paddingTop: location.pathname === "/" || location.pathname === "/dashboard" ? "40px" : "80px",
  //     [theme.breakpoints.up("sm")]: {
  //       paddingTop: "48px",
  //       height: "100%",
  //       "& > div": {
  //         position: "relative",
  //         height: "100%"
  //       }
  //     }
  //   }
  // }))

  if (appContext.loadingAppstructure) {
    return (
      <StyledMain openDrawer={appContext.isMainNavOpen}>
        <LoadingPage />
      </StyledMain>
    )
  }

  return (
    <StyledMain openDrawer={appContext.isMainNavOpen}>
      <StyledSwitchWrapper>
        <ScrollToTop />
        <Switch>
          <Route exact path="/index.html">
            <Redirect to="/" />
          </Route>
          <Route exact path="/">
            {appContext.isAuth ? <Dashboard /> : <SignedOutPage />}
          </Route>
          {routes.map((route, key) => {
            return (
              <Route
                exact
                {...props}
                key={key}
                path={route.path}
                render={(props) => {
                  return appContext.isAuth ? (
                    <RenderComponent
                      {...props}
                      name={route.componentName}
                      knownComponents={knownComponents}
                    />
                  ) : (
                    <SignedOutPage />
                  )
                }}></Route>
            )
          })}
        </Switch>
      </StyledSwitchWrapper>
    </StyledMain>
  )
}

export default PagesRouter
